import React from 'react'
import { Timeline } from 'antd'
import { FormattedMessage } from 'react-intl'

const RoutePoints = props => {
  const { points } = props
  const getColor = (index, array) => {
    if (index === 0) {
      return 'green'
    }

    if (index === array.length - 1) {
      return 'red'
    }

    return 'gray'
  }

  const getColorCode = color => {
    switch (color) {
      case 'green':
        return '#46be8a'
      case 'red':
        return '#fb434a'
      default:
        return '#888'
    }
  }

  const getText = color => {
    switch (color) {
      case 'green':
        return <FormattedMessage id="common.trip_details.pickup" />
      case 'red':
        return <FormattedMessage id="common.trip_details.dropoff" />
      default:
        return <FormattedMessage id="common.trip_details.pass" />
    }
  }

  return (
    <Timeline className="mt-2">
      {points.map((el, index, array) => {
        const color = getColor(index, array)

        return (
          <Timeline.Item color={color} key={JSON.stringify(el)}>
            <div style={{ color: getColorCode(color), paddingTop: 2 }}>{getText(color)}</div>
            <div className="font-weight-bold">{el.name}</div>
            <div className="text-muted">{el.address_name}</div>
          </Timeline.Item>
        )
      })}
    </Timeline>
  )
}

export default RoutePoints
